/** Sticky avatar color per user, derived deterministically from `user.id`. */

import { themeConfig } from '@gap/shared/theme'

export type AvatarColorKey = 'pink' | 'orange' | 'violet' | 'teal' | 'lightblue' | 'yellow' | 'mint'

const PALETTE: AvatarColorKey[] = ['pink', 'orange', 'violet', 'teal', 'lightblue', 'yellow', 'mint']

const ACCENT_COLOURS: Record<AvatarColorKey, { background: string; foreground: string }> = {
   pink: { background: themeConfig.accents.pink[200], foreground: themeConfig.accents.pink[800] },
   orange: { background: themeConfig.accents.orange[200], foreground: themeConfig.accents.orange[800] },
   violet: { background: themeConfig.accents.violet[200], foreground: themeConfig.accents.violet[800] },
   teal: { background: themeConfig.accents.teal[200], foreground: themeConfig.accents.teal[800] },
   lightblue: { background: themeConfig.accents.lightblue[200], foreground: themeConfig.accents.lightblue[800] },
   yellow: { background: themeConfig.accents.yellow[300], foreground: themeConfig.accents.yellow[900] },
   mint: { background: themeConfig.system.success[300], foreground: themeConfig.system.success[800] },
}

export function colorKeyForUserId(userId: string): AvatarColorKey {
   let hash = 0
   for (let charIndex = 0; charIndex < userId.length; charIndex++) {
      hash = ((hash << 5) - hash + userId.charCodeAt(charIndex)) | 0
   }
   return PALETTE[Math.abs(hash) % PALETTE.length]
}

export function avatarColors(colorKey: AvatarColorKey | undefined, deactivated: boolean) {
   if (deactivated) return { background: themeConfig.grey[200], foreground: 'rgba(0, 0, 0, 0.38)' }
   return ACCENT_COLOURS[colorKey ?? 'violet']
}

/** First letter of a name for the single-letter avatar. */
export function initialFor(name: string | undefined): string {
   return (name ?? '').trim().charAt(0).toUpperCase() || '?'
}

export function isAvatarColor(value: string | undefined): value is AvatarColorKey {
   return !!value && (PALETTE as string[]).includes(value)
}
